import React from "react";
import { STATUS_STYLES, LABELS } from "@/lib/constants";

export default function StatusBadge({ status, testid }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cls}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
